import React from "react"

import renderElement from "../../../utils/renderElement"

import "./cta-streak.scss"

export default function CTAStreakComponent({ article, isBlog }) {
  return (
    <section
      className="further-details cta-streak"
      style={{ background: article.background_color }}
    >
      <div className={isBlog ? " " : "container"}>
        <div
          className="text-center px-2 py-5"
          dangerouslySetInnerHTML={renderElement(article.streak_content)}
        ></div>
      </div>
    </section>
  )
}
